import { Component, Input } from '@angular/core';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import {
  BaseFilterCellComponent,
  FilterService,
} from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'gd-dropdown-filter',
    templateUrl: './dropdown-filter.component.html',
    styleUrls: ['./dropdown-filter.component.css'],
    imports: [DropDownListComponent]
})
export class DropdownFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): unknown {
    const filter = this.filterByField(this.valueField)
    return filter ? filter.value : null
  }

  @Input() declare filter: CompositeFilterDescriptor;
  @Input() public data: unknown[]
  @Input() public textField: string
  @Input() public valueField: string
  @Input() public defaultTextString = 'Select Item...'
  @Input() public defaultValueString: string = null

  public get defaultItem(): unknown {
    return this.defaultTextString
  }

  constructor(filterService: FilterService) {
    super(filterService)
  }

  public onChange(value: unknown): void {
    this.applyFilter(
      value === null || value === this.defaultTextString // value of the default item
        ? this.removeFilter(this.valueField) // remove the filter
        : this.updateFilter({
            // add a filter for the field with the value
            field: this.valueField,
            operator: 'eq',
            value: value,
          }),
    ) // update the root filter
  }
}
